<template>
<div>
  <transition name="fade">

    <div class="" v-if="widgfinishvis">
      <WidgFinish />
    </div>
  </transition>
  <b-container v-if="widguservis" class="box formback estisize">
    <b-row align-h="center">
      <b-col cols="12">
        <h2>
          <span class="awesome">Awesome!<br /></span><span style="color:grey;"> Let's create a user.</span>
        </h2>
        <input id="phone_number" ref="phone_number" v-model="input.phone_number" type="text" class="frmField" placeholder="Phone number">
        <input id="email" v-model="input.email" type="email" name="email" class="frmField" placeholder="Enter email address">
        <b-col class="text-center">
          <p v-if="errors.length">
            <br>
            <b>Please correct the following error(s):</b>
            <span style="color: red">
              <li v-for="error in errors">{{ error }}</li>
            </span>
          </p>
        </b-col>
        <button class="btn btn-success" @click="checkForm">
          Submit
        </button>
      </b-col>
    </b-row>
  </b-container>
  <transition name="fade">
    <div v-if="visible" class="vue-back-to-top" :style="`bottom:${this.bottom};left:${this.left};`">
      <Main />
    </div>
  </transition>
</div>
</template>

<script>
export default {
  name: 'WidgUser',

  data() {
    return {
      address: 'Address',
      country: 'Country',
      city: 'City',
      zip_code: 'Zip Code',
      province: 'Province',
      employment: 'Employment',
      step: 4,
      errors: [],
      widguservis: true,
      widgfinishvis: false,
      vendorOfUser: '',
      numberOfPayments: 12,
      frequency: '',
      currentYear: '',
      loanRatio: '',
      approvedLoan: '',
      maxLoanAmount: '',
      finalLoanAmount: '',
      repairAmount: '',
      boundaryLimit: '',
      minimumLoan: '',
      visible: false,
      input: {
        first_name: 'First Name',
        last_name: 'Last Name',
        email: null,
        phone_number: null,
        password: Math.random().toString(36).slice(-5),
      },
      show: false
    }
  },
  mounted() {
    this.$refs.phone_number.focus();
    const {
      year,
      make,
      model,
      trim: trim_level,
      vehicleStyle: vehicle_style,
      vin,
      odometerReading: odometer_reading,
      carDetails: car_details,
      payment: loan_amount,
      paymentFrequency: frequency,
      numberOfPayments: number_of_payments,
      paymentTotal: payment_total,
      boundaryAmount: boundary_amount,
      approvedLoanAmount: max_loan_amount,
      loanRequested: loan_requested,
      repairOfferAmount: repair_offer_amount,
      paymentPeriod: term,
      newAPR: new_apr,
      vendorToPay: vendor_to_pay,
      firstPaymentDay: first_payment_day,
      totalPayments: total_payments,
      costOfFinancing: cost_of_financing,
      frequencyText: frequency_text,
      paymentFees: payment_fees,
      selectedProduct: selected_product,
      productPrice: product_price,
      vendor,
    } = this.$store.state.userData
  },
  created() {

    console.log('the vendor is' + this.$store.state.userData.selectedVendor)
    console.log(this.$store.state.userData)
    this.vendorOfUser = this.$store.state.userData.selectedVendor
    this.currentYear = new Date().getFullYear()
    this.loanRatio = 1 - (this.currentYear - this.$store.state.userData.year) / 35
    this.approvedLoan = Math.max(1500, (Math.trunc((this.$store.state.userData.marketValue * 0.3 * 0.7) * this.loanRatio)))
    this.repairAmount = this.$store.state.userData.repairOfferAmount
    // Check the maximum amount possible to take if the approved loan is lower than the repair offer
    this.maxLoanAmount =
      this.approvedLoan > this.repairAmount ? this.repairAmount : this.approvedLoan
    this.boundaryLimit = this.maxLoanAmount > 10000 ? 10000 : this.maxLoanAmount
    // Check if the customer needs to bring cash because his approved amount doesn't cover the repair offer
    this.minimumLoan =
      this.approvedLoan > this.repairAmount ? 500 : this.repairAmount - this.approvedLoan
    // set default highest loan possible
    this.finalLoanAmount = this.boundaryLimit
    // store the data
    this.$store.state.userData.boundaryAmount = this.approvedLoan > 10000 ? 10000 : this.approvedLoan
    this.$store.state.userData.paymentTotal = this.finalLoanAmount
    this.frequency = this.$store.state.userData.frequency
    // is the below line important?
  },
  watch: {
    'input.email': {
      handler: function(after, before) {
        this.input.email = this.input.email.toLowerCase()
      },
      deep: true
    }
  },
  methods: {
    onpicOne() {
      if ('parentIFrame' in window)
        window.parentIFrame.size(256);
      return false;
    },
    closewidg() {
      if ('parentIFrame' in window)
        window.parentIFrame.size(70);
      return false;
    },
    closeWin() {
      return [this.widguservis = false, this.visible = true, widgfinishvis = false]
    },
    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    checkForm: function(e) {
      console.log('selected vendor' + this.selectedVendor);
      this.errors = [];
      if (!this.input.first_name) {
        this.errors.push("First Name required.");
      }
      if (!this.input.last_name) {
        this.errors.push("Last Name required.");
      }
      if (!this.input.password) {
        this.errors.push("Password required.");
      }
      if (!this.input.email) {
        this.errors.push('Email required.');
      } else if (!this.validEmail(this.input.email)) {
        this.errors.push('Valid email required.');
      }
      if (!this.errors.length) {
        console.log('creating user');
                this.axios
                .post(`${process.env.ROOT_API}/user/create`, {
                  first_name: this.input.first_name,
                  last_name: this.input.last_name,
                  email: this.input.email,
                  password: this.input.password,
                  vendor_of_user: this.vendorOfUser,
                  phone_number: this.input.phone_number
                })
          .then(response => {
            localStorage.setItem('user-id', response.data.data.id)
            localStorage.setItem('user-token', response.data.data.token)
            const id = localStorage.getItem('user-id')
            const token = localStorage.getItem('user-token')
            console.log('updating user');
            const updateUserPromise = this.axios.put(
              `${process.env.ROOT_API}/user/${id}`,
              {
                address: this.address,
                city: this.city,
                zip_code: this.zip_code,
                province: this.province,
                country: this.country,
                employment: this.employment,
              }, {
                headers: {
                  authorization: `Token ${token}`,
                },
              }
            )
            const {
              year,
              make,
              model,
              trim: trim_level,
              vehicleStyle: vehicle_style,
              vin,
              loanRequested: amount,
              odometerReading: odometer_reading,
              carDetails: car_details,
              payment: loan_amount,
              paymentFrequency: frequency,
              numberOfPayments: number_of_payments,
              paymentTotal: payment_total,
              boundaryAmount: boundary_amount,
              approvedLoanAmount: max_loan_amount,
              loanRequested: loan_requested,
              repairOfferAmount: repair_offer_amount,
              paymentPeriod: term,
              newAPR: new_apr,
              vendorToPay: vendor_to_pay,
              firstPaymentDay: first_payment_day,
              totalPayments: total_payments,
              costOfFinancing: cost_of_financing,
              frequencyText: frequency_text,
              paymentFees: payment_fees,
              selectedProduct: selected_product,
              productPrice: product_price,
              selectedVendor: vendor,
            } = this.$store.state.userData
            const createLoanPromise = this.axios.post(
              `${process.env.ROOT_API}/user/loan/create`,
              {
                make,
                model,
                year,
                trim_level,
                vin,
                car_details,
                vehicle_style,
                odometer_reading,
                loan_amount,
                frequency,
                number_of_payments,
                payment_total,
                boundary_amount,
                max_loan_amount,
                loan_requested,
                repair_offer_amount,
                term,
                new_apr,
                vendor_to_pay,
                first_payment_day,
                total_payments,
                cost_of_financing,
                frequency_text,
                selected_product,
                product_price,
                vendor,
              }, {
                headers: {
                  authorization: `Token ${token}`,
                },
              }
            )
            Promise.all([updateUserPromise, createLoanPromise]).then(() => {
              location.href = `${process.env.DASHBOARD_URL}/#/login?token=${token}`

              // this.showCompleted = true
              // this.$store.commit('setStep');
              // return this.showCompleted
            }).catch(error => {
              if (error.message === 'Request failed with status code 409') {
                this.$toasted.show('Dashoad could not be loaded')
              } else {
                this.$toasted.show('An error occurred please try again')
              }
            })
          }).catch(error => {
            if (error.message === 'Request failed with status code 409') {
              this.$toasted.show('User with this email already exists')
            } else {
              this.$toasted.show('An error occurred please try again')
            }
          })
        this.widguservis = false;
        this.widgfinishvis = true;
        this.onpicOne();
      }

      e.preventDefault();
    },

  },
}
</script>

<style scoped>
.formback {
  background-color: white;
}

@media screen and (max-width: 430px) {
  .estisize {
    width: 200px
  }
}

@media screen and (min-width: 431px) {
  .estisize {
    width: 340px
  }
}

.element-margin {
  text-align: center;
}

.container {
  width: 340px;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
}

.frmField {
  background-color: white;
  color: #495057;
  line-height: 1.25;
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  border: 0;
  padding: 10px;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  width: 90%;
}

.Password_field {
  margin-top: 1rem;
}

select,
input {
  max-width: 340px;
  margin: 1rem auto 0 auto;
}

#retype_password {
  margin: 0 auto 0 auto;
}

select:focus,
input:focus {
  box-shadow: none;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 1rem;
}

h3 {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #7b7e7d;
}

.awesome {
  color: #40c991;
}


.element-margin {
  text-align: center;
}

.element-center {
  margin: 0 auto;
}

.box {
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 2rem;
  border-radius: 10px;
}

.box .separator .line {
  width: 1px;
  height: 40%;
  background-color: #a803a8;
}

.box .separator .or {
  width: fit-content;
  height: 10%;
  display: flex;
  align-items: center;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 3rem;
  color: #fff;
}

.input-icon {
  position: relative;
}

.input-icon>i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
  font-style: normal;
}

.input-icon>input {
  padding-left: 25px;
  padding-right: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}


ele div.x {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  display: inline;
  float: right;
}

.ele div.x.slow {
  -webkit-transition-duration: 1s;
  transition-duration: 1s;
}

ul {
  list-style: none;
  float: right;
  display: block;
  width: 100%;
}

li {
  display: inline;
  width: 25%;
  float: right;
}

.ele {
  width: 25%;
  display: inline;
}

.x {
  float: left;
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #CCC;
  border-radius: 2px;
  border: solid 2px #FFF;
  transition: all .3s ease-out;
  cursor: pointer;
}

.x.large {
  width: 33px;
  height: 33px;
}

.x.medium {
  width: 20px;
  height: 20px;
}

.x.small {
  width: 10px;
  height: 10px;
}

.x.switch {
  width: 15px;
  height: 15px;
}

.x.grow {}

.x.spin:hover {
  background: #40c991;
  transform: rotate(180deg);
}

.x.flop:hover {
  background: #40c991;
  transform: rotate(90deg);
}

.x.t:hover {
  background: #40c991;
  transform: rotate(45deg);
}

.x.shift:hover {
  background: #40c991;
}

.x b {
  display: block;
  position: absolute;
  height: 0;
  width: 0;
  padding: 0;
  margin: 0;
}

.x.small b {
  border: solid 5px rgba(255, 255, 255, 0);
}

.x.medium b {
  border: solid 10px rgba(255, 255, 255, 0);
}

.x.large b {
  border: solid 15px rgba(255, 255, 255, 0);
}

.x.switch b {
  border: solid 10px rgba(255, 255, 255, 0);
}

.x b:nth-child(1) {
  border-top-color: #FFF;
  top: -2px;
}

.x b:nth-child(2) {
  border-left-color: #FFF;
  left: -2px;
}

.x b:nth-child(3) {
  border-bottom-color: #FFF;
  bottom: -2px;
}

.x b:nth-child(4) {
  border-right-color: #FFF;
  right: -2px;
}

.checkmark {
  display: block;
  margin: 0 auto;
  text-align: center;
}

.checkmark:after {
  content: '';
  display: block;
  border: solid #000;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkmark.large:after {
  width: 12px;
  height: 24px;

}

.checkmark.medium:after {
  width: 8px;
  height: 16px;

}

.checkmark.small:after {
  width: 4px;
  height: 8px;
}

.checkmark.tiny:after {
  width: 1px;
  height: 2px;
  border-width: 0 1px 1px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/widguser.vue